import type { PanelProps } from "../shared";
import { TextRecordsPanel } from "./text-records-panel";

/**
 * TikTok feed clips. Only ops fills this bag; generation never writes it.
 * An empty bag leaves the app playing the clips bundled with the phone release.
 */
export function TikTokPanel(props: PanelProps) {
  return (
    <TextRecordsPanel
      {...props}
      path="device.apps.tiktok"
      title="TikTok"
      rowTitleKeys={["author_handle", "caption"]}
      fields={[
        { key: "video_url", label: "视频文件", kind: "video_url" },
        { key: "author_handle", label: "账号", placeholder: "roomwithnolights" },
        { key: "caption", label: "文案", multiline: true, rows: 3 },
        { key: "avatar_url", label: "头像", kind: "media_url" },
        { key: "likes_count", label: "点赞数", kind: "number" },
        { key: "comments_count", label: "评论数", kind: "number" },
        { key: "saves_count", label: "收藏数", kind: "number" },
        { key: "shares_count", label: "分享数", kind: "number" },
      ]}
    />
  );
}
